// extracted by mini-css-extract-plugin
export default {"heading":"BasicInformation_heading__BaOa8","wrapper":"BasicInformation_wrapper__rFV-X"};